import { render, staticRenderFns } from "./VAttrList.vue?vue&type=template&id=c9ff419a&scoped=true"
import script from "./VAttrList.vue?vue&type=script&lang=ts"
export * from "./VAttrList.vue?vue&type=script&lang=ts"
import style0 from "./VAttrList.vue?vue&type=style&index=0&id=c9ff419a&prod&lang=scss&scoped=true"
import style1 from "./VAttrList.vue?vue&type=style&index=1&id=c9ff419a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ff419a",
  null
  
)

export default component.exports